import React, { memo, FC } from 'react';
import Image from 'next/image';

const NoodleAI: FC<{ size?: number }> = memo(({ size = 24 }) => (
  <Image src="/images/dashboard/noodle-ai-fallback.png" alt="" width={size} height={size} />
));

NoodleAI.displayName = 'NoodleAI';

export default NoodleAI;
